export const RIDER_VERIFY_NUDGE_DISMISS_KEY = 'riderVerifyNudgeDismissed';
